import type {FormData, ListField, Step} from './types';

export const TOTAL_STEPS = 4;

export const INITIAL_FORM_DATA: FormData = {
    // Stap 1
    name: '',
    email: '',
    workPhone: '',
    birthDate: '',
    address: '',
    role: 'Psycholoog',
    startYearOneOnOne: '',
    mainQualifications: [],
    qualificationYears: {},
    otherQualificationText: '',
    deliveryMode: '',
    clientHoursRange: '',
    availableDays: [],
    languages: [],

    // Stap 2
    expertise: [],
    expertiseLevels: {},
    expertiseEducation: {},
    expertiseYears: {},
    otherExpertiseText: '',
    top3Expertise: [],

    // Stap 3
    openForBridgeCare: null,
    baAwareness: false,
    methodologies: [],
    methodologyFrequencies: {},
    methodologyEducation: {},
    methodologyExpRange: {},
    otherMethodologyText: '',

    // Stap 4
    finalConsent: false,
};

export function updateField<K extends keyof FormData>(
    formData: FormData,
    field: K,
    value: FormData[K],
): FormData {
    return {...formData, [field]: value};
}

export function toggleList(
    formData: FormData,
    field: ListField,
    value: string,
    max: number | null = null,
): FormData {
    const current = formData[field];

    if (max && !current.includes(value) && current.length >= max) {
        return formData;
    }

    const updated = current.includes(value)
        ? current.filter((item) => item !== value)
        : [...current, value];

    return updateField(formData, field, updated);
}

export function nextStep(step: Step): Step {
    return Math.min(step + 1, TOTAL_STEPS) as Step;
}

export function prevStep(step: Step): Step {
    return Math.max(step - 1, 1) as Step;
}

export function canProceed(step: Step, formData: FormData): boolean {
    if (step === 1) {
        return Boolean(formData.name && formData.email && formData.mainQualifications.length > 0);
    }

    if (step === 2) {
        return formData.expertise.length > 0;
    }

    if (step === 4) {
        return formData.finalConsent;
    }

    return true;
}
